module.exports = __webpack_public_path__ + "static/img/data.ec25078.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/prizes/data.png
// module id = 98G/
// module chunks = 1